import React from 'react'
import '../styles/index.scss'
import BatchReproductionPage from "./BatchReproductionPage"

function BatchReproductionContainer() {
    return (
        <div className="BatchReproductionContainer">
            <BatchReproductionPage/>
        </div>
    )
}

export default BatchReproductionContainer